"use es6";

const noop = any => any;
export { noop };